module.exports = __webpack_public_path__ + "img/4.9ab56415.jpeg";